import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BonusqrService, BonoPacienteDinamicoBody } from 'src/app/shared/servicio/bonusqr/bonusqr.service';

@Component({
  selector: 'app-bono-dinamico',
  templateUrl: './bono-dinamico.component.html',
  styleUrls: ['./bono-dinamico.component.css'],
})
export class BonoDinamicoComponent implements OnInit, OnDestroy {
  token: string;
  loading = true;
  submitting = false;

  medicDisplayName = '';
  specialties: { id: number; name: string }[] = [];
  isActive = false;
  notFound = false;
  errorMessage = '';

  secondsRemaining = 0;
  expired = false;
  private _countdown: any;

  redeemed = false;
  couponId = '';
  successMessage = '';
  formErrorMessage = '';

  constructor(private _route: ActivatedRoute, private _bonusqr: BonusqrService) {}

  ngOnInit(): void {
    this.token = this._route.snapshot.paramMap.get('token');
    this.verify();
  }

  ngOnDestroy(): void {
    this._stopCountdown();
  }

  verify(): void {
    this.loading = true;
    this.notFound = false;
    this.expired = false;
    this.errorMessage = '';

    this._bonusqr.verifyDynamicQr(this.token).subscribe(
      (data: any) => {
        // Un 200 significa que el token está vigente (lo vencido/usado llega como 410).
        this.medicDisplayName = data.medic_name;
        this.specialties = data.specialties || [];
        this.isActive = true;
        this.secondsRemaining = data.seconds_remaining;
        this.loading = false;
        this._startCountdown();
      },
      (error) => {
        this.loading = false;
        if (error.status === 410) {
          this.expired = true;
          this.errorMessage = (error.error && error.error.message) || 'Este codigo ha expirado, solicite uno nuevo';
        } else {
          this.notFound = true;
          this.errorMessage = (error.error && error.error.message) || 'Codigo QR no valido';
        }
      }
    );
  }

  private _startCountdown(): void {
    this._stopCountdown();
    this._countdown = setInterval(() => {
      this.secondsRemaining--;
      if (this.secondsRemaining <= 0) {
        this.secondsRemaining = 0;
        this.expired = true;
        this.errorMessage = this.errorMessage || 'Este codigo ha expirado, solicite uno nuevo al medico';
        this._stopCountdown();
      }
    }, 1000);
  }

  private _stopCountdown(): void {
    if (this._countdown) {
      clearInterval(this._countdown);
      this._countdown = null;
    }
  }

  onFormSubmit(body: BonoPacienteDinamicoBody): void {
    if (this.expired) {
      return;
    }
    this.submitting = true;
    this.formErrorMessage = '';

    this._bonusqr.redeemDynamicQr(this.token, body).subscribe(
      (data: any) => {
        this.submitting = false;
        this.redeemed = true;
        this.couponId = data.coupon_id;
        this.successMessage = data.message;
        this._stopCountdown();
      },
      (error) => {
        this.submitting = false;
        if (error.status === 410) {
          this.expired = true;
          this.formErrorMessage = (error.error && error.error.message) || 'El codigo expiro, pedile uno nuevo al medico';
        } else {
          this.formErrorMessage = (error.error && error.error.message) || 'Datos no validos';
        }
      }
    );
  }
}
